import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default {
  name: 'video_up',
  components: {
    videoTable: function videoTable() {
      return import('./video_page');
    }
  }
};